// extracted by mini-css-extract-plugin
export default {"title":"I5kVJ","open":"UtRQc","collapse":"mYEl6"};